export const projectsMeta = {

  "google-sheets-calendar-synchronizer": {
    displayName: "Google Sheets & Calendar Synchronizer",
    description:
      "A Google Apps Script that bridges Sheets and Calendar, turn spreadsheet rows into calendar events automatically. Built for real productivity needs, used and starred by developers worldwide.",
    stack: ["JavaScript", "Google Apps Script", "Google Workspace API"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "base-wp-theme": {
    displayName: "Base WP Theme",
    description:
      "A production-ready WordPress starter theme with Webpack, Babel, SASS, ESLint, PHPCS, and GitHub Actions CI/CD. Built to deploy — not just to scaffold.",
    stack: ["PHP", "JavaScript", "SCSS", "Webpack", "GitHub Actions"],
    liveUrl: "https://base-wp-theme.sarahjobs.com",
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "wxyz-blocks": {
    displayName: "WXYZ Blocks — Multi-Block Plugin Architecture",
    description:
      "A developer-focused WordPress plugin that demonstrates how to manage multiple Gutenberg blocks inside a single codebase — with a block manager pattern, automatic registration via block.json, custom WP-CLI commands, and PHPUnit tests.",
    stack: ["PHP", "JavaScript", "Gutenberg", "WP-CLI", "PHPUnit"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "reusable-wp-workflows": {
    displayName: "Reusable WordPress GitHub Actions Workflows",
    description:
      "A collection of reusable CI/CD workflows for WordPress projects, covering deployment, coding standards, and release automation. Built to be dropped into any WP project.",
    stack: ["GitHub Actions", "YAML", "WordPress"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "wp-api-renderflex": {
    displayName: "WP API RenderFlex",
    description:
      "A WordPress plugin that exposes flexible REST API endpoints, designed for headless and decoupled architectures. Built for projects where WordPress is the backend, not the frontend.",
    stack: ["PHP", "WordPress REST API", "JavaScript"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "plugin-order-status-admin": {
    displayName: "WooCommerce Order Status Manager",
    description:
      "A custom WordPress plugin that extends WooCommerce with additional order status management in the admin panel. Built for a client with complex fulfillment workflows.",
    stack: ["PHP", "WordPress", "WooCommerce"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "plugin-product-fields-admin": {
    displayName: "WooCommerce Custom Product Fields",
    description:
      "A WordPress plugin that adds custom admin fields to WooCommerce products, built to meet specific client requirements without bloating the setup with off-the-shelf plugins.",
    stack: ["PHP", "WordPress", "WooCommerce"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "purpleish-theme": {
    displayName: "Purpleish — WordPress Theme",
    description:
      "A custom WordPress theme built from scratch. Fun fact: this one got me hired once.",
    stack: ["PHP", "CSS", "JavaScript", "WordPress"],
    type: "personal",
    featured: true,
    hidden: false,
  },

  "scroll-bar-indicator": {
    displayName: "Scroll Bar Indicator",
    description:
      "A lightweight npm package that adds a reading progress indicator to any webpage. Small, zero-dependency, and published on npm.",
    stack: ["JavaScript", "npm"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "qrcode-pack": {
    displayName: "QR Code Pack",
    description:
      "A published npm package for generating QR codes, straightforward, dependency-light, and available for anyone to use.",
    stack: ["JavaScript", "npm"],
    type: "open-source",
    featured: true,
    hidden: false,
  },

  "doubly-even-code-checker": {
    displayName: "Doubly-Even Code Checker",
    description:
      "A C++ and JavaScript experiment inspired by physicist James Gates Jr.'s discovery of error-correcting codes inside the equations of supersymmetry. Part code, part philosophy, and apparently the kind of thing that gets you hired.",
    articleUrl:
      "https://sarahsiqueira.com/post/did-a-physicist-find-error-correcting-code-in-reality-and-what-that-means-to-us-developers-19b7/2645552",
    stack: ["C++", "JavaScript"],
    type: "personal",
    featured: true,
    hidden: false,
  },

  // Secondary — shown but not featured
  "docker-wordpress": {
    displayName: "Docker WordPress",
    description:
      "A Docker setup for local WordPress development, opinionated, clean, and ready to use.",
    stack: ["Docker", "WordPress", "PHP"],
    type: "open-source",
    featured: false,
    hidden: false,
  },

  "base-wp-plugin": {
    displayName: "Base WP Plugin",
    description:
      "A starter WordPress plugin boilerplate following WordPress coding standards, a clean base to build from.",
    stack: ["PHP", "WordPress"],
    type: "open-source",
    featured: false,
    hidden: false,
  },

  "base-gutenberg-block": {
    displayName: "Base Gutenberg Block",
    description:
      "A minimal starter for building custom Gutenberg blocks, following official WordPress block development conventions.",
    stack: ["JavaScript", "PHP", "Gutenberg"],
    type: "open-source",
    featured: false,
    hidden: false,
  },

  "plugin-cpt-manager": {
    displayName: "Custom Post Type Manager",
    description:
      "A WordPress plugin to register and manage custom post types and taxonomies programmatically.",
    stack: ["PHP", "WordPress"],
    type: "open-source",
    featured: false,
    hidden: false,
  },

  // Hidden — not shown in portfolio
  "sarahcssiqueira": {
    hidden: true,
  },
};